import { Trans } from "react-i18next";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import { FILE_NAME } from "../../Dialog/types/enums";
import TextLink from "../../TextLink/TextLink";
import { TEXT_LINK_SIZES } from "../../TextLink/types";

export interface SampleTemplateProps {
  fileName: FILE_NAME;
}

const SampleTemplate = ({ fileName }: SampleTemplateProps) => {
  return (
    <Typography
      variant="body2Medium"
      component="div"
      sx={{ color: colors.gray700, margin: "16px 0" }}
    >
      <Trans i18nKey="Dialog##download sample file message">
        Download a
        <TextLink
          data-testid="file-sample-template-link"
          size={TEXT_LINK_SIZES.Normal}
          href={`/static/${fileName}.csv`}
          download
        >
          sample CSV template
        </TextLink>
        to see an example of the format required.
      </Trans>
    </Typography>
  );
};

export default SampleTemplate;
